<template>
    <div>
    <div>
      <modal size="medium">
          <div slot="header">Créer une nouvelle journée de championnat</div>
          <div slot="body">
            <div class="row columns">
                <div class="large-8 large-centered">
                    <i class="fa fa-header " aria-hidden="true"></i> Titre :
                    <input type="text" placeholder="texte libre"  v-model="title">
                    <i class="fa fa-commenting-o" aria-hidden="true"></i> Description :
                    <input type="text" placeholder="texte libre"  v-model="desc">
                </div>
            </div>
            <div v-if="needDesc" class="row columns alert-msg">
                vous devez saisir une description
            </div>
          </div>
          <div slot="footer" class="panel-footer" >
              <div class="row columns">
                <button class="large-4 light-grey-button" @click="$emit('closeMessage')">Annuler</button>
                <button class="large-4 large-offset-2 alert" @click="create">Créer</button>
              </div>
          </div>
          <br>
          
      </modal>
    </div>
    </div>
</template>
<script>
import modal from './modal.vue'
import week from '../../api/match-week.api'

export default {
  name: 'createWeekModal',
  components: {
    modal
  },
  props: {
    'league_id': 0
  },
  methods: {
    create () {
      if (this.desc === null) {
        this.needDesc = true
        return
      }
      let newWeek = {}
      newWeek.title = this.title
      newWeek.description = this.desc
      newWeek.league = this.league_id
      week.api.createWeek(newWeek)
      .then(response => {
        this.showMessage = true
        this.$emit('createdWeek')
      }, error => {
        console.log('impossible to create week from create week from create week modal')
        console.log(error)
      })
    }
  },
  data () {
    return {
      title: null,
      desc: null,
      needDesc: false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-mask {
  position:fixed
}
.alert-msg {
  color:red;
  font-weight:300;
  font-size: 0.9rem
}
</style>



// WEBPACK FOOTER //
// create-week-modal.vue?460fb241